import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import * as authenticationTypes from '../../types';
import { IMessage, IPortalInfo } from '../../../shared/types';


@Component({
  selector: 'tr-mfa-login',
  templateUrl: './mfa-login.component.html',
  //styleUrls: ['./mfa-login.component.scss']
})
export class MfaLoginComponent implements OnInit {
  @Output() mfaLogin = new EventEmitter<authenticationTypes.ICredentials>();
  @Output() mailMfaCode = new EventEmitter<any>();
  @Input() isBusy: boolean;
  @Input() message: IMessage;
  @Input() portalInfo: IPortalInfo;
  @Input() mfaAuthSetup: authenticationTypes.IMfaAuthSetup;
  @Input() mfaAuthCodeType: authenticationTypes.IMfaAuthCodeType;
  @Input() currentAccount: authenticationTypes.IAccount;
    
  private mfaCodeMask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];

  constructor() {
  }

  ngOnInit() {
  }

  submitMFA(mfaCode: string) {
    if (mfaCode.length == 6) {
      const mfaLoginCredentials: authenticationTypes.ICredentials = {
        username: this.currentAccount.username,
        password: this.currentAccount.password,
        mfacode: mfaCode
      }

      this.mfaLogin.emit(mfaLoginCredentials);
    }
  }

  resendMFACode() {
    this.mailMfaCode.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/authentication/components/mfa-login/mfa-login.component.ts